module.exports = {
      id: "comm-album-usage",
      viewBox: "0 0 230.223 54.026",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#comm-album",
      toString: function () {
        return this.url;
      }
    }